import logger from './logger';

export interface HandledServerError {
  details: string;
  message: string;
  path: string;
  statusCode: number;
  timestamp: string;
}

export interface UnhandledServerError {
  message: string;
}

class ErrorHandler {
  view(error: unknown): void {
    const unknownMessage = 'An unknown error occurred.';

    try {
      const err = error as { response?: { data?: HandledServerError | UnhandledServerError }; message?: string };

      if (err?.response?.data) {
        const data = err.response.data;

        const isHandledServerError = (value: HandledServerError | UnhandledServerError): value is HandledServerError => {
          return 'statusCode' in value;
        };

        const errorMessage = isHandledServerError(data) ? `${data.message} (Status Code: ${data.statusCode})` : data.message || unknownMessage;

        logger.showError(`Error: ${errorMessage}`);
      } else {
        logger.showError(err?.message || unknownMessage);
      }
    } catch (e) {
      logger.showError(`Error handler encountered an error: ${(e as Error).message}`);
    }
  }
}

const error = new ErrorHandler();
export default error;
